import { Icon20CameraOutline } from '@vkontakte/icons';
import { Spacing, Text, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import memoriesImage from 'img/family-content/empty-block-memories.png';
import memoriesImageDark from 'img/family-content/empty-block-memories-dark.png';
import { xray } from 'lib/xray';
import React, { type ReactElement } from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import styles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';

export const SharedMemories = (): ReactElement => {
    const onClick = (): void => {
        xray.send('empty_family-album_create', { p: 'cloud' });
        toolbarActions.create('familyAlbum', 'emptyState', undefined, '', true, true);
    };

    return (
        <div className={styles.card} onClick={onClick} data-qa-id="family-shared-memories">
            <div className={styles.icon}>
                <Icon20CameraOutline data-qa-id="family-shared-memories-icon" />
            </div>
            <Spacing size={24} style={{ pointerEvents: 'none' }} />
            <Title level="2" data-qa-id="family-shared-memories-title">
                Добавьте в него первые фото и видео{' '}
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-shared-memories-content">Файлы в альбоме увидят родные, но только те, что есть в подписке</Text>
            <img
                src={isDarkTheme ? memoriesImageDark : memoriesImage}
                alt="Общие воспоминания"
                className={classNames(styles.image, styles.memoriesImage)}
                data-qa-id="family-shared-memories-image"
            />
        </div>
    );
};
